// Lectura del payload de un JWT SIN verificar la firma. Verificar es trabajo
// del backend; acá solo hace falta leer `exp` para decidir si vale la pena
// discar el WebSocket con este token o refrescarlo primero (un handshake con
// token vencido es un 401 garantizado).

import { urlBase64ToUint8Array } from "./base64url.js";

/**
 * Milisegundos epoch en que vence el JWT, o `null` si no se puede determinar
 * (token ausente, malformado, o sin claim `exp` numérico).
 *
 * @param {string|null|undefined} token
 * @returns {number|null}
 */
export function getJwtExpiryMs(token) {
  if (typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    // TextDecoder y no atob directo: el payload es UTF-8 y atob devuelve
    // latin1 — un claim con tildes rompería el JSON.parse.
    const payload = JSON.parse(
      new globalThis.TextDecoder().decode(urlBase64ToUint8Array(parts[1])),
    );
    return typeof payload.exp === "number" ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

/**
 * ¿El token está vencido o a punto de vencer? `skewMs` cubre el desfase de
 * reloj con el server y el viaje del handshake: un token con menos vida que
 * eso llega muerto al backend aunque acá figure vigente.
 *
 * Token ilegible o sin exp → `false`: se disca igual y el camino del 401
 * (racha de handshakes fallidos) recupera. Mentir "vencido" sin saberlo
 * bloquearía conexiones sanas.
 *
 * @param {string|null|undefined} token
 * @param {number} [skewMs]
 * @returns {boolean}
 */
export function isTokenExpiringSoon(token, skewMs = 30_000) {
  const expMs = getJwtExpiryMs(token);
  if (expMs == null) return false;
  return expMs - skewMs <= Date.now();
}
